import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapProjectsMap = {
  show: async(props) => {
    const { default: MapPage } = await import('@/vue_widgets/mlap/map/index.vue')
    createVueApp(MapPage, { props, layoutProps: { noPadding: true } })
  }
}
